import { Endpoint } from '@models/prediction';
import { ConfigProps } from '@components/config/ConfigPanel';
import Config from '@utils/config';

export const FACE_MATCHING_CONFIG: ConfigProps = {
    selectedEndpoint: Endpoint.FaceMatching,
    selectedSecureMode: Config.defaultConfig.mode,
    selectedMultiframeMode: Config.defaultConfig.multiframeMode,
    endpoints: [{ key: Endpoint.FaceMatching }],
    selectedAgeDisplayMode: Config.defaultConfig.ageDisplayMode,
    selectedLanguage: Config.defaultConfig.language,
    consent: false,
};

export enum FaceMatchingPanelTabs {
    Guide = 'Guide',
    Capture = 'Capture',
    Settings = 'Settings',
}
